<template>
  <div class="s9pro">
    <div class="s9pro-image">
      <img ref="s9-image" src="../../static/home/s9pro.png" alt="">
    </div>
    <div class="s9pro-text">
      <span class="s9pro-text-one">S9 Pro</span><br>
      <span class="s9pro-text-two">{{ $t('series.delight') }}</span>
    </div>

    <div class="s9pro-cut-image">
      <img src="../../static/home/s9pro_cut.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  name: 'S9Pro',
  data() {
    return {
      isMobile: false // 移动端判断标识
    }
  },
  methods: {
    checkDevice() {
      this.isMobile = window.innerWidth <= 768;
    },
    handleResize() {
      this.checkDevice();
    }
  },
  mounted() {
    this.checkDevice();
    window.addEventListener('resize', this.handleResize);

    this.$nextTick(() => {
      const textY = this.isMobile ? 50 : 100;
      const cutImageY = this.isMobile ? 100 : 200;
      const animationDuration = this.isMobile ? 1 : 1.5;

      this.$gsap.set(['.s9pro-text'], {
        opacity: 0,
        y: textY,
        visibility: true
      })

      this.$gsap.set(['.s9pro-cut-image'], {
        opacity: 0,
        y: cutImageY,
        visibility: true
      })

      const masterTimeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: '.s9pro',
          start: this.isMobile ? 'top 90%' : 'top 80%',
          end: this.isMobile ? 'bottom 30%' : 'bottom 20%',
          markers: false,
          toggleActions: 'play none none none',
        }
      });

      masterTimeline.from(this.$refs['s9-image'], {
        opacity: 0,
        duration: animationDuration,
        ease: 'power2.in',
      })

      masterTimeline.to(this.$refs['s9-image'], {
        duration: animationDuration,
        filter: 'blur(5px)',
        ease: 'power2.in',
      }, this.isMobile ? 0.5 : 1)

      masterTimeline.to('.s9pro-cut-image', {
        opacity: 1,
        y: 0,
        duration: animationDuration,
        ease: 'power2.in',
      }, this.isMobile ? 0.5 : 1)

      masterTimeline.to(this.$refs['s9-image'], {
        opacity: 0,
        duration: this.isMobile ? 1.5 : 2,
        ease: 'power2.in',
      }, this.isMobile ? 1 : 3)

      masterTimeline.to('.s9pro-cut-image', {
        duration: this.isMobile ? 1.5 : 2,
        scale: 1.05,
        ease: 'power2.in',
      }, this.isMobile ? 1.5 : 3)

      masterTimeline.to(['.s9pro-text'], {
        opacity: 1,
        duration: this.isMobile ? 1.5 : 2,
        y: 0,
        ease: 'power2.in',
      }, this.isMobile ? 1.5 : 3)

    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>
<style scoped>
.s9pro {
  width: 100%;
  height: 700px;
  margin-top: 100px;
  margin-bottom: 100px;
  position: relative;
}

.s9pro-image {
  display: flex;
  justify-content: center;
}

.s9pro-image img {
  position: absolute;
  margin: 0 auto;
  width: 65%;
}

.s9pro-text {
  margin-top: 20px;
  text-align: center;
}

.s9pro-text-one {
  font-size: var(--font-size-xl);
}

.s9pro-text-two {
  font-size: var(--font-size-xl2);
  background-image: linear-gradient(to right, #1b78b9, pink);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.s9pro-cut-image {
  width: 100%;
  display: flex;
  justify-content: center;

  img {
    width: 70%;
  }
}

/* 手机端适配 - 屏幕宽度小于768px时 */
@media (max-width: 768px) {
  .s9pro {
    height: auto;
    min-height: 500px;
    margin-top: 100px; /* 重点：手机端顶部额外增加到100px距离 */
    margin-bottom: 50px;
    padding: 0 15px;
    box-sizing: border-box;
  }

  .s9pro-image img {
    width: 95%;
  }

  .s9pro-text {
    margin-top: 15px;
    padding: 0 10px;
  }

  .s9pro-text-one {
    font-size: clamp(1.5rem, 5vw, var(--font-size-xl));
  }

  .s9pro-text-two {
    font-size: clamp(1.8rem, 6vw, var(--font-size-xl2));
  }

  .s9pro-cut-image {
    img {
      width: 100%;
    }
  }
}

/* 小屏手机适配 */
@media (max-width: 480px) {
  .s9pro {
    min-height: 400px;
    margin-top: 100px; /* 小屏手机同样保持顶部100px距离 */
    margin-bottom: 30px;
  }
}
</style>
